import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/glommen-mjosen-logo-circle@2x.png")